import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import SortIcon from 'icons/Sort.icon';
import { DrawerNavigation } from 'router/subrouters/DataRoom/components/SideDrawer/SideDrawer.component';
import useDrawerKeyboardNavigation from 'hooks/useDrawerKeyboardNavigation';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import {
  DRAWER_NAVIGATION_DIRECTION,
  DrawerRowNavigatedEventProps,
} from 'models/MixpanelEvents';

import './DrawerNavigationButtons.styles.scss';
import './DrawerNavigationButtons.styles.responsive.scss';

type DrawerNavigationButtonsProps = {
  className?: string;
} & DrawerNavigation;

const DrawerNavigationButtons: React.FC<DrawerNavigationButtonsProps> = (
  props,
) => {
  const { className, onPrev, onNext } = props;

  const classes = classNames('drawer-navigation-buttons', className);

  const { t } = useTranslation();

  const getMixpanelProps = useGetMixpanelProps();

  const handleOnPrev = useCallback(() => {
    mixpanelService.drawerRowNavigated(
      getMixpanelProps({
        direction: DRAWER_NAVIGATION_DIRECTION.PREVIOUS,
      }) as DrawerRowNavigatedEventProps,
    );
    onPrev?.();
  }, [getMixpanelProps, onPrev]);

  const handleOnNext = useCallback(() => {
    mixpanelService.drawerRowNavigated(
      getMixpanelProps({
        direction: DRAWER_NAVIGATION_DIRECTION.NEXT,
      }) as DrawerRowNavigatedEventProps,
    );
    onNext?.();
  }, [getMixpanelProps, onNext]);

  useDrawerKeyboardNavigation({
    ...(onPrev && { onPrev: handleOnPrev }),
    ...(onNext && { onNext: handleOnNext }),
  });

  if (!onPrev && !onNext) return null;

  return (
    <nav className={classes}>
      <Button
        type="button"
        variant="icon"
        icon={SortIcon}
        className="drawer-navigation-buttons__prev"
        aria-label={t('previousRow')}
        disabled={!onPrev}
        onClick={handleOnPrev}
      />
      <Button
        type="button"
        variant="icon"
        icon={SortIcon}
        aria-label={t('nextRow')}
        disabled={!onNext}
        onClick={handleOnNext}
      />
    </nav>
  );
};

export default DrawerNavigationButtons;
